module.exports = "<div class=\"d3-chart\" #groupedbarchart></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/grouped-barchart/grouped-barchart.component.html
// module id = ./src/app/grouped-barchart/grouped-barchart.component.html
// module chunks = main